/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    v-if="results && results.scores"
    tabindex="-1"
  >
    {{ simpleScore }}
  </div>
</template>

<script>
import ChartHelper from '../utils/ChartHelper';

export default {
  mixins: [ChartHelper],
  props: ['recording', 'wavesurfer', 'metric', 'speakerNum', 'tooltipId'],
  computed: {
    simpleScore() {
      let score = Math.round(this.results.scores[this.metric]);
      if (this.metric === 'talkVsListen') {
        score += '%';
      }

      return score;
    }
  },
  mounted() {
    this._addTooltip(this.tooltipId, this.recording, this.metric);
  },
};
</script>
